module.exports = __webpack_public_path__ + "static/img-build-hexapod-robot-d803a4f7f75ed4a4a9bdc3a120b73553.png";